import { DEVICE_TYPE, MARGIN, SIZE } from "constants/variables";
import styled from "styled-components";

export const ContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${SIZE.max32};
  padding: ${SIZE.max120} ${MARGIN.fix32};
`;

export const TitleWrapper = styled.div`
  width: 65%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
  }
`;

export const AnimationStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  .canvas-desktop {
    display: none;
    @media screen and (min-width: 1240px) {
      display: flex;
    }
  }
  .canvas-tablet {
    display: none;
    @media screen and (min-width: 800px) and (max-width: 1239px) {
      display: flex;
    }
  }
  .canvas-mobile {
    display: flex;
    @media screen and (min-width: 799px) {
      display: none;
    }
  }
`;

export const AnimationStyledMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media screen and (min-width: 1300px) {
    display: none;
  }
`;
